import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxsModule } from '@ngxs/store';
import * as Sentry from '@sentry/angular-ivy';
import { Router } from '@angular/router';

import { environment } from '../environments/environment';
import { CanAccessGuard } from './app-can-access-guard.routing';
import { AppCanDeactivateGuardRouting } from './app-can-deactivate-guard.routing';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Environment } from './website/services/environment.service';
import { EvergladesEnvironment } from './website/services/everglades-environment.service';
import { ServicesModule } from './website/services/services.module';
import { TemplateService } from './website/services/template.service';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { DashboardModule } from './website/modules/dashboard/dashboard.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CanAccessNeedsVerifyGuard } from './app-can-access-needs-verify-guard.routing';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MicroserviceAuthInterceptor } from './core/auth/interceptors/microservice-auth.interceptor';
import { AuthState } from './core/auth/state/auth.state';
import { ToastService } from '../../projects/client/src/app/shared/services';
import { TenantConfigService } from '../../tenant-config/tenant-config.service';

const ngxsLogger = false;

const imports = ngxsLogger ? [NgxsLoggerPluginModule.forRoot()] : [];

@NgModule({
  declarations: [AppComponent],
  imports: [
    NgxsModule.forRoot([AuthState], {
      developmentMode: !environment.production,
      compatibility: { strictContentSecurityPolicy: true }
    }),
    NgxsRouterPluginModule.forRoot(),
    ...imports,
    BrowserModule,
    BrowserAnimationsModule,
    ServicesModule,
    AppRoutingModule,
    DashboardModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.serviceWorkerEnabled
    })
  ],
  providers: [
    CanAccessGuard,
    CanAccessNeedsVerifyGuard,
    AppCanDeactivateGuardRouting,
    ServicesModule,
    TemplateService,
    ToastService,
    { provide: Environment, useClass: EvergladesEnvironment },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false
      })
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (tenantConfig: TenantConfigService) => () => tenantConfig.load().toPromise(),
      deps: [TenantConfigService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MicroserviceAuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
